import { Button } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import useTitle from 'hooks/useTitle';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFreight } from 'useStores/useFreight';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FreightsModal from './FreightsModal';
import FreightDetails from './FreightDetails';
import OrderForm from './OrderForm';

const NewFreightOrder = () => {
  useTitle('افزدون سفارش جدید');
  const setTitle = useFreight((state) => state.setTitle);
  const setCategory = useFreight((state) => state.setCategory);
  const setFreightsModal = useFreight((state) => state.setOpenFreightsModal);
  const choosedFreight = useFreight((state) => state.choosedFreight);
  const resetNewOrderForm = useFreight((state) => state.resetNewOrderForm);
  const location = useLocation();

  useEffect(() => {
    setTitle('افزدون سفارش جدید');
    setCategory('جهت افزودن سفارش جهت صاحب ‌بار بصورت دستی');
    return () => resetNewOrderForm();
  }, [location.pathname]);
  return (
    <div>
      <FreightsModal />
      <Button
        className="mb-4"
        variant="contained"
        color="secondary"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => setFreightsModal(true)}
      >
        {!choosedFreight ? ' انتخاب باربری' : 'تغییر باربری'}
      </Button>
      {choosedFreight && <FreightDetails />}
      {choosedFreight && <OrderForm />}
    </div>
  );
};

export default NewFreightOrder;
